export default 'Tolls';
